/* eslint-disable react/prop-types */
import ClockIcon from "@Icons/ClockIcon";
import styles from "./citySuggestionsDesktop.module.scss";
import { FC, useCallback, useRef, useState } from "react";
import LocationIcon from "@Icons/LocationIcon";
import UniversityIcon from "@Icons/UniversityIcon";
import { useHistory } from "hooks/useHistory";
import customHistoryPush from "@Utils/customHistoryPush";
import wrapperHOC from "@Utils/wrapperHOC";
import config from "@Config/index";
import useTranslationHook from "hooks/useTranslationHook";
import useWhitelabel from "hooks/useWhitelabel";
import { convertToWhitelabelURL } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";

const CitySuggestionsDesktop: FC<any> = ({
  cities,
  title,
  handleGtagEvents,
  // handleGtagScrollEvents,
  gtagEventAction,
  // gtagScrollAction,
  singleRowScrollable = false,
  twoRowScrollable = false,
  backendSorted = false,
}) => {
  const { isDemoSubdomain, partner_uuid } = useWhitelabel();
  const history = useHistory();
  const handleCityClick = (canonicalName = null, regionType = null, name = null) => {
    if (handleGtagEvents) {
      handleGtagEvents({
        action: gtagEventAction,
        label: canonicalName,
        canonical_name: canonicalName,
        entity_name: name,
        entity_type: regionType,
        entity_grid: title.toLowerCase().replace("⚡", ""),
      });
    }
    customHistoryPush(
      history,
      convertToWhitelabelURL(`/places/search/${canonicalName}`, isDemoSubdomain, partner_uuid),
    );

    // window.location.href = `/places/search/${canonicalName}`;
  };
  // const handleScroll = () => {
  //   if (handleGtagScrollEvents) {
  //     handleGtagScrollEvents({
  //       action: gtagScrollAction,
  //       entity_grid: title.toLowerCase().replace("⚡", ""),
  //     });
  //   }
  // };
  const { t } = useTranslationHook();
  let titleIcon = <LocationIcon />;
  if (title.includes("Recently Searched")) {
    titleIcon = <ClockIcon height={18} width={18} />;
  } else if (title.includes("Top Universities")) {
    titleIcon = <UniversityIcon />;
  }

  const uniFlag = title.includes("Top Universities");

  const validCities = cities?.filter((city: any) => city.name && city.canonical_name) || [];

  const shouldUseTwoRow = twoRowScrollable && validCities.length > (uniFlag ? 5 : 10);

  // Track whether the scrollable container has reached the end
  const containerRef = useRef<HTMLDivElement>(null);
  const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);

  const handleContainerScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    setIsScrolledToEnd(atEnd);
  }, []);

  const getContainerClass = () => {
    if (shouldUseTwoRow) {
      return `${styles.panelSectionListContainerTwoRow}${
        isScrolledToEnd ? ` ${styles.noFade}` : ""
      }`;
    }
    if (singleRowScrollable || twoRowScrollable) {
      return `${styles.panelSectionListContainerScrollable}${
        isScrolledToEnd ? ` ${styles.noFade}` : ""
      }`;
    }
    return styles.panelSectionListContainer;
  };

  const getListClass = () => {
    if (shouldUseTwoRow) return styles.panelSectionListTwoRow;
    if (singleRowScrollable || twoRowScrollable) return styles.panelSectionListSingleRow;
    return styles.panelSectionList;
  };

  const renderCityItem = (city: any, i: number) => (
    <div
      role="none"
      onClick={() => handleCityClick(city.canonical_name, city?.region_type, city.name)}
      key={`${city.id + city.canonical_name}topArr${i}`}
      className={styles.panelText}
      data-testid={title}
    >
      {title == "Recently Searched" ? <ClockIcon /> : ""}
      <div
        data-testid={`search-suggestion-${title}-cities`}
        className={uniFlag ? "" : styles.panelTextInner}
      >
        {config.IS_CHINA_APP && city.name_zh ? `${city.name_zh} (${city.name})` : city.name}
      </div>
    </div>
  );

  const renderTwoRowLayout = () => {
    let row1Items: any[];
    let row2Items: any[];

    if (backendSorted) {
      // Backend already interleaved: first half = row 1, second half = row 2
      const midpoint = Math.ceil(validCities.length / 2);
      row1Items = validCities.slice(0, midpoint);
      row2Items = validCities.slice(midpoint);
    } else {
      // Frontend interleaving: even indices → row 1, odd indices → row 2
      row1Items = validCities.filter((_: any, i: number) => i % 2 === 0);
      row2Items = validCities.filter((_: any, i: number) => i % 2 !== 0);
    }

    return (
      <>
        <div className={styles.panelSectionListTwoRowInner}>
          {row1Items.map((city: any, i: number) => renderCityItem(city, i))}
        </div>
        <div className={styles.panelSectionListTwoRowInner}>
          {row2Items.map((city: any, i: number) => renderCityItem(city, i))}
        </div>
      </>
    );
  };

  return (
    <div>
      <div className={styles.panelSectionTitle} data-testid={`search-suggestion-${title}-heading`}>
        {titleIcon} {t(title)}
      </div>
      <div className={getContainerClass()} ref={containerRef} onScroll={handleContainerScroll}>
        {shouldUseTwoRow ? (
          <div className={getListClass()}>{renderTwoRowLayout()}</div>
        ) : (
          <div className={getListClass()}>
            {validCities.map((city: any, i: number) => renderCityItem(city, i))}
          </div>
        )}
      </div>
    </div>
  );
};

export default wrapperHOC(CitySuggestionsDesktop, {
  componentName: "CitySuggestionsDesktop-SearchModalDesktop-Global",
  showForChina: true,
});
